import { render, staticRenderFns } from "./RadioButtonCard.vue?vue&type=template&id=5042f651&scoped=true&"
import script from "./RadioButtonCard.vue?vue&type=script&lang=js&"
export * from "./RadioButtonCard.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtonCard.vue?vue&type=style&index=0&id=5042f651&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5042f651",
  null
  
)

export default component.exports